import { create } from 'zustand/react'

export type ToastVariant = 'success' | 'error' | 'info'

export type ToastPayload = {
  message: string
  variant?: ToastVariant
  durationMs?: number
}

export type ToastItem = {
  id: number
  message: string
  variant: ToastVariant
  durationMs: number
}

type ToastState = {
  toasts: ToastItem[]
  showToast: (payload: ToastPayload) => void
  hideToast: (id: number) => void
  clearToasts: () => void
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  showToast: ({ message, variant = 'info', durationMs = 1800 }) =>
    set((state) => ({
      toasts: [
        ...state.toasts,
        {
          id: Date.now() + Math.floor(Math.random() * 1000),
          message,
          variant,
          durationMs,
        },
      ],
    })),
  hideToast: (id: number) =>
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    })),
  clearToasts: () => set({ toasts: [] }),
}))
